import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import Home from './Home';
import Admin from './Admin';

Vue.use(VueRouter);
const routes = [
  { path: '/', component: Home },
  { path: '/admin', component: Admin }
]
Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  routes
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
